export * from './IconAxisX';
